import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";

import Common from "./Common";
import User from "./User";
import Quiz from "./Quiz";
import Blog from "./Blog";

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    common: Common,
    user: User,
    quiz: Quiz,
    blog: Blog,
  });
